import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

// items: [{ label, to? }] — el último es la página actual (sin link)
export function Breadcrumbs({ items = [] }) {
  return (
    <nav aria-label="Ruta de navegación" data-testid="breadcrumbs" className="bg-white/90 backdrop-blur border-b border-gray-100">
      <ol className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center flex-wrap gap-1.5 text-sm">
        <li>
          <Link to="/" data-testid="breadcrumb-home" className="inline-flex items-center gap-1 text-gray-500 hover:text-navy transition-colors">
            <Home className="h-4 w-4" /> <span className="hidden sm:inline">Inicio</span>
          </Link>
        </li>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1.5 min-w-0">
              <ChevronRight className="h-4 w-4 text-gray-300 shrink-0" />
              {it.to && !last ? (
                <Link to={it.to} data-testid={`breadcrumb-link-${i}`} className="text-gray-500 hover:text-navy font-medium transition-colors truncate max-w-[42vw] sm:max-w-none">
                  {it.label}
                </Link>
              ) : (
                <span data-testid="breadcrumb-current" aria-current="page" className="text-navy font-semibold truncate max-w-[52vw] sm:max-w-none">
                  {it.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
